import { useQuery } from "@tanstack/react-query";
import { usersQueries } from "@surgia/api/src/queryStore/shared/users";

interface UseGetUserOptions {
  enabled?: boolean;
  refetchOnWindowFocus?: boolean;
  staleTime?: number;
  cacheTime?: number;
}

interface GetUserParams {
  component_id: number;
  tenant_id: number;
  branches_ids: string;
  user_id: string;
}

export const useGetUser = (
  params: GetUserParams,
  options?: UseGetUserOptions
) => {
  return useQuery({
    ...usersQueries.queries.getUsers({
      ...params,
      name: "",
      profile_status: "",
      size: 1,
      page: 0,
      id: params.user_id,
    }),
    select: (data: any) => {
      // Return the first user from the array since we're querying by specific user_id
      const user = data?.data?.[0];
      if (!user) return null;

      return {
        ...user,
        id: user.user_id,
        name: user.full_name,
        details: {
          email: user.email,
          phone: user.mobile,
        },
        role: user.user_groups,
        status: user.status,
        createdAt: user.creation_date,
        lastLogin: user.last_login,
        branches: user.user_branches,
      };
    },
    enabled: options?.enabled ?? true,
  });
};
